import * as React from 'react';

import { Button, Input, InputAdornment, InputAdornmentButton, Modal, UIHeading3 } from '@cian/ui-kit';
import { IconActionClose16, IconFileEdit16 } from '@cian/ui-kit-design-tokens/icons';

import styles from './styles.css';

export interface IEditModalProps {
  isOpen: boolean;
  initialName?: string;
  onOpenChange: () => void;
  onSave: (value: string) => void;
}

export const EditModal: React.FC<IEditModalProps> = ({ isOpen, initialName, onOpenChange, onSave }) => {
  const [name, setName] = React.useState(initialName || '');
  const nameRef = React.useRef(name);

  const handleChangeName = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
    nameRef.current = e.target.value;
  }, []);

  const handleClear = React.useCallback(() => {
    setName('');
  }, []);

  const handleSubmit = React.useCallback(() => {
    onSave(nameRef.current);
  }, [onSave]);

  const handlePreventSubmit = React.useCallback((e: React.FormEvent) => {
    e.preventDefault();
  }, []);

  return (
    <Modal
      header={<UIHeading3>Редактирование поиска</UIHeading3>}
      open={isOpen}
      onOpenChange={onOpenChange}
      body={
        <form onSubmit={handlePreventSubmit} className={styles['container']}>
          <Input
            invalid={name.trim() === ''}
            width="100%"
            name="title"
            placeholder="Добавьте название"
            value={name}
            onChange={handleChangeName}
            rightAdornment={
              name !== '' ? (
                <InputAdornmentButton onClick={handleClear}>
                  <IconActionClose16 color="icon-main-default" display="inline-block" />
                </InputAdornmentButton>
              ) : (
                <InputAdornment>
                  <IconFileEdit16 color="icon-main-default" display="inline-block" />
                </InputAdornment>
              )
            }
            size="M"
          />
          <Button
            fullWidth
            size="L"
            theme="fill_primary"
            type="submit"
            onClick={handleSubmit}
            disabled={name.trim() === ''}
          >
            Сохранить поиск
          </Button>
        </form>
      }
    />
  );
};
